var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdminView',[_c('h1',{staticClass:"title-1"},[_vm._v("Familles d'exercices")]),(_vm.families.length > 0)?_c('ExercisesFamiliesForm',{attrs:{"families":_vm.families}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }